// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fi","advertDetailHeaderLocation__value":"c-m_fj"};